import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User } from '@shared/models';
import { Invitation } from '@shared/models/invitation.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InvitationService {
  private httpClient = inject(HttpClient);

  endpoint = `${environment.endpoint}/invitations`;

  create(invitation: {
    email: string;
    lastName: string;
    firstName: string;
  }): Observable<Invitation> {
    return this.httpClient.post<Invitation>(this.endpoint, invitation);
  }

  getAll(): Observable<Invitation[]> {
    return this.httpClient.get<Invitation[]>(this.endpoint);
  }

  delete(id: string): Observable<Invitation> {
    return this.httpClient.delete<Invitation>(`${this.endpoint}/${id}`);
  }

  get(id: string): Observable<{ invitation: Invitation; user: User }> {
    return this.httpClient.get<{ invitation: Invitation; user: User }>(
      `${this.endpoint}/${id}`
    );
  }

  accept(id: string, user: User): Observable<Invitation> {
    return this.httpClient.post<Invitation>(
      `${this.endpoint}/${id}/accept`,
      user
    );
  }
}
